<!--金币列表-->
<template>
  <div  class="app-container">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="120px">
          <el-form-item label="会员卡号:">
            <el-input v-model="queryParam.cardId" placeholder=""></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
        <el-button type="warning" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-card>

    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div slot="footer" class="dialog-footer-1" >
        <div class="spec-buton-box">
          <el-button class="operator-btn" type="primary" @click="onGoldUpdate()">金币调整</el-button>
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>
        <div class="spec-buton-box">
          <el-button class="operator-btn" type="primary" @click="onGoldExchange()">金币消费</el-button>
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>
          
          
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        max-height="520"
        v-loading="listLoading"
        border>
        <el-table-column prop="id" label="ID" ></el-table-column>
        <el-table-column prop="storeFrontId" label="门店ID" ></el-table-column>
        <el-table-column prop="cardId" label="会员卡" ></el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
        <el-table-column prop="correlationId" label="关联信息" ></el-table-column>
        <el-table-column prop="num" label="数量" ></el-table-column>
        <el-table-column prop="createTime" label="操作时间" ></el-table-column>
        <!--<el-table-column label="操作">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button  type="primary" size="mini" class="operator-btn" @click="onGoldUpdate(scope.row)" >金币调整</el-button>-->
            <!--<el-button  type="primary" size="mini" class="operator-btn" @click="onGoldExchange(scope.row)" >金币消费</el-button>-->
          <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <el-dialog
            title="金币调整"
            :visible.sync="visibleGoldRecord"
            width="50%"
            center
    >
      <div class="root-container">
        <el-form :model="serverParam" label-width="140px">
          <el-form-item  label="会员卡号:" prop="remark"  >
            <el-input :readonly="true" style="width: 300px" v-model="serverParam.cardId"></el-input>
          </el-form-item>
          <el-form-item v-if="doFlag =='1'" label="备注:" prop="remark"  >
            <el-input  style="width: 300px" v-model="serverParam.remark"></el-input>
          </el-form-item>
          <el-form-item label="剩余金币:" prop="totalGold"  >
            <el-input :readonly="true" style="width: 300px;"  class="te" v-model="serverParam.totalGold"></el-input>
          </el-form-item>
          <el-form-item v-if="doFlag =='2'" label="金币:">
            &nbsp;&nbsp;&nbsp;<el-input-number v-model="serverParam.gold" :precision="0"
                                               :step="10" ></el-input-number>
          </el-form-item>
          <el-form-item v-if="doFlag =='1'"  label="金币:">
            &nbsp;&nbsp;&nbsp;<el-input-number v-model="serverParam.gold2" :precision="0"
                                               :step="-10" :max="0"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelGold()">取消</el-button>
        <el-button type="primary" @click="confirmGold()">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import {queryGoldRecode,saveGoldRecode,getTotalGold} from "../../api/goldRecord";
  import commonUtils from "../../utils/commonUtils";
  import globaldata from "../../utils/globaldata";
  import messageUtils from "../../utils/messageUtils";

  export default {

    data() {
      return {
        listLoading: false,
        visibleGoldRecord:false,
        queryParam:{
          cardId : '',
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },
        //表单结果
        tableData: [
        ],
        serverParam:{
          cardId:'',
          remark:'',
          totalGold:0,
          gold:0,
          gold2:0,
        },
        doFlag : '1',//金币兑换(消费)
        isVip: globaldata.getAdminStore().isVip,
      }
    },
    created(){
      this.queryParam.cardId=this.$route.query.cardId;
      if( this.queryParam.cardId !=undefined && this.queryParam.cardId.length>1){
        this.flechList();
      }
    },
    mounted() {

    },
    methods: {

      flechList(){
        if( this.queryParam.cardId ==undefined || this.queryParam.cardId.length<2){
          messageUtils.errorMsg(this,"请输入正确的卡号查询后再操作!");
          return false;
        }
        this.listLoading = true;

        let param = {
          cardId:this.queryParam.cardId,
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize,
        }
        queryGoldRecode(param).then(response =>
        {
          this.listLoading = false;
          console.info(response.data);
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.queryParam.totalPage = data.total;
          this.refreshData(data.records);

        })
      },
      //刷新页面数据
      refreshData(list){

        if (commonUtils.isObjectNull(list)){
          return;
        }

        let tableDataList = [];
        for (let i = 0;i< list.length;++i){
          let data = {
            id: list[i].id,
            storeFrontId: list[i].storeFrontId,
            cardId: list[i].cardId,
            remark: list[i].remark,
            num:list[i].num,
            createTime:list[i].createTime,
            correlationId:list[i].correlationId,
          };
          tableDataList.push(data);
        }

        this.tableData = tableDataList;
      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.flechList();
      },
      onGoldUpdate(){
        if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
        if( this.queryParam.cardId ==undefined || this.queryParam.cardId.length<2){
          messageUtils.errorMsg(this,"请输入正确的卡号查询后再操作!");
          return false;
        }
        this.getTotalGoldNum(this.queryParam.cardId);
        this.doFlag = '2';
        this.serverParam.remark = '员工金币调整';
        this.serverParam.cardId = this.queryParam.cardId;
        this.visibleGoldRecord = true;
      },
      onGoldExchange(){//金币兑换消费
        if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
        if( this.queryParam.cardId ==undefined || this.queryParam.cardId.length<2){
          messageUtils.errorMsg(this,"请输入正确的卡号查询后再操作!");
          return false;
        }
        this.getTotalGoldNum(this.queryParam.cardId);
        this.doFlag = '1';
        this.serverParam.cardId = this.queryParam.cardId;
        this.visibleGoldRecord = true;
      },
      cancelGold(){
        this.visibleGoldRecord = false;
        this.serverParam.gold = 0;
        this.serverParam.gold2 = 0;
        this.serverParam.remark = '';
      },
      confirmGold(){//调整金币
        let gold = 0;
        if(this.doFlag == '1'){
          gold = this.serverParam.gold2;
        }else{
          gold = this.serverParam.gold;
        }
        let param = {
          cardId:this.serverParam.cardId,
          remark:this.serverParam.remark,
          num:gold,
          storeFrontId:globaldata.getAdminStore().storeFrontId,
        }
        this.queryParam.cardId = this.serverParam.cardId;
        saveGoldRecode(param).then(response =>
        {
          this.visibleGoldRecord = false;
          console.info(response);
          let data = response;
          if (data.code == 20000){
            messageUtils.successMsg(this,data.message);
            this.serverParam.remark = '';
            this.serverParam.gold = 0;
            this.serverParam.gold2 = 0;
            this.flechList();
          } else {
            messageUtils.errorMsg(this,data.message);
          }
        })
      },
      getTotalGoldNum(cardId){
        let param = {
          cardId:cardId,
        }
        getTotalGold(param).then(response =>
        {

          console.info(response.data);
          let data = response.data;
          console.info(data[0].num);
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.serverParam.totalGold = data[0].num;
        })
  }
    }
  }
</script>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

  .te>>>input{
    color: red;
  }
</style>




// WEBPACK FOOTER //
// src/views/gold/index.vue